import React from "react";
import { Spinner, Button, Row, Col, FormGroup, Label, Input } from "reactstrap";
import LeadsImportStep2TableItem from "./ImportStep2TableItem";

const LeadsImportStep2 = ({
  step,
  loading,
  onSubmit,
  tableData,
  appendableColumns,
  setAppendableColumns,
  onTableColumnUnSelect,
  onTableColumnSelect,
  sources,
  loadingSources,
  selectedSourceId,
  onSourceChange,
  showAddSource,
  onShowAddSourceChange,
  newSourceName,
  onNewSourceNameChange,
  newSourceLogo,
  onNewSourceLogoChange,
  addingSource,
  onAddSource,
}) => {
  if (step === 1) {
    return (
      <div className="px-md-5 w-100">
        <div className="d-flex align-items-center gap-2 mb-2" style={{ opacity: 0.5 }}>
          <div
            style={{
              width: "20px",
              height: "20px",
              backgroundColor: "#697277",
              color: "white",
              borderRadius: "50%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              fontSize: "14px",
              fontWeight: 500,
            }}
          >
            2
          </div>
          <div style={{ fontSize: "20px", fontWeight: 500, color: "#697277" }}>
            Check table mapping
          </div>
        </div>
      </div>
    );
  }
  return (
    <div className="px-md-5 pb-5 w-100">
      <div className="d-flex align-items-center gap-2 mb-2">
        <div
          style={{
            width: "20px",
            height: "20px",
            backgroundColor: "#697277",
            color: "white",
            borderRadius: "50%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            fontSize: "14px",
            fontWeight: 500,

          }}
        >
          2
        </div>
        <div style={{ fontSize: "20px", fontWeight: 500, color: "#697277" }}>
          Check table mapping
        </div>
      </div>

      <Row className="d-none d-md-flex pt-2 px-3">
        {["FILE HEADER", "DATA", "APPEND FIRST"].map((text, index) => (
          <Col key={index}>
            <div style={{ fontSize: "18px", fontWeight: 500, color: "#697277", textAlign: "left" }}>
              {text}
            </div>
          </Col>
        ))}
      </Row>

      {tableData?.columns?.map((column, i) => {
        const allTableData = tableData?.data;
        let tableItem = { column: column?.Header, data: [] };

        if (column?.appendedValue) {
          tableItem.appendedValue = column?.appendedValue;
        }

        for (let i = 0; i < allTableData?.length; i++) {
          if (allTableData[i][`${column?.Header}`]) {
            tableItem = {
              ...tableItem,
              data: [...tableItem?.data, allTableData[i][`${column?.Header}`]],
            };
            if (tableItem?.data.length === 3) break;
          }
        }

        return (
          <LeadsImportStep2TableItem
            key={i}
            table={tableItem}
            appendableColumns={appendableColumns}
            onAppendableColumnsChange={setAppendableColumns}
            onTableColumnUnSelect={onTableColumnUnSelect}
            onTableColumnSelect={onTableColumnSelect}
          />
        );
      })}

      {/* Source Selection Section */}
      <div className="py-4 px-3 border-top">
        <h5 className="mb-3" style={{ fontSize: "18px", fontWeight: 500, color: "#697277" }}>
          Select Source
        </h5>

        <Row className="mb-3">
          <Col md={6}>
            <FormGroup>
              <Label style={{ fontWeight: 500, fontSize: "14px" }}>
                Source <span className="text-danger">*</span>
              </Label>
              <Input
                type="select"
                value={selectedSourceId || ''}
                onChange={(e) => {
                  const val = e.target.value;
                  if (val === '__add_new__') {
                    onShowAddSourceChange(true);
                    return;
                  }
                  onSourceChange(val ? Number(val) : null);
                }}
                style={{ fontSize: "14px" }}
              >
                <option value="">
                  {loadingSources ? 'Loading sources...' : 'Select a source'}
                </option>
                {sources.map((source) => (
                  <option key={source.id} value={source.id}>
                    {source.name}
                  </option>
                ))}
                <option value="__add_new__">+ Add New Source</option>
              </Input>
            </FormGroup>
          </Col>
        </Row>

        {showAddSource && (
          <div className="mb-3 p-3 border rounded" style={{ backgroundColor: '#f8f9fa' }}>
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h6 className="mb-0">Add New Source</h6>
              <button
                type="button"
                className="btn btn-sm btn-outline-secondary"
                onClick={() => {
                  onShowAddSourceChange(false);
                  onNewSourceNameChange('');
                  onNewSourceLogoChange('');
                }}
              >
                Cancel
              </button>
            </div>
            <Row className="align-items-center">
              <Col md={4}>
                <FormGroup className="mb-0">
                  <Label>Source Name *</Label>
                  <Input
                    value={newSourceName}
                    onChange={(e) => onNewSourceNameChange(e.target.value)}
                    placeholder="e.g. Pitti, White Milano"
                  />
                </FormGroup>
              </Col>
              <Col md={4}>
                <FormGroup className="mb-0">
                  <Label>Logo URL</Label>
                  <Input
                    value={newSourceLogo}
                    onChange={(e) => onNewSourceLogoChange(e.target.value)}
                    placeholder="https://example.com/logo.png (Optional)"
                  />
                </FormGroup>
              </Col>
              <Col md={4}>
                <Button
                  color="success"
                  onClick={onAddSource}
                  disabled={addingSource || !newSourceName.trim()}
                >
                  {addingSource ? <Spinner size="sm" /> : 'Add Source'}
                </Button>
              </Col>
            </Row>
          </div>
        )}
      </div>

      <div className="py-4 d-flex justify-content-center align-items-center">
        <Button color="primary" disabled={loading || !selectedSourceId} onClick={onSubmit}>
          <span style={{ fontSize: "15px", fontWeight: 500, textTransform: "none" }}>
            Confirm your Import
          </span>
          {loading && <Spinner size="sm" color="light" className="ms-2" />}
        </Button>
      </div>
    </div>
  );
};

export default LeadsImportStep2;
